export default "__VITE_ASSET__Cqefl8gX__"